import { employeeInputValue } from '../employeeInputValidation';
export default function DocumentsStep({
  formData,
  setFormData,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: employeeInputValue(name, value, prev[name]),
    }));
  };

  return (
    <div className="space-y-8">

      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-6">
          Documents
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Aadhaar Number */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Aadhaar Number
            </label>

            <input
              type="text"
              name="aadhaarNumber"
              aria-label="Aadhaar number"
              inputMode="numeric"
              maxLength={12}
              pattern="[0-9]{12}"
              title="Exactly 12 digits"
              value={formData.aadhaarNumber}
              onChange={handleChange}
              placeholder="12 digits, without spaces"
              className="
                w-full px-4 py-3 rounded-xl border border-gray-200
                focus:outline-none focus:ring-2 focus:ring-red-800
              "
            />
          </div>

          {/* PAN */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              PAN Number
            </label>

            <input
              type="text"
              name="panNumber"
              aria-label="PAN number"
              maxLength={10}
              pattern="[A-Z]{5}[0-9]{4}[A-Z]"
              title="Five letters, four digits, one final letter: ABCDE1234F"
              value={formData.panNumber}
              onChange={handleChange}
              placeholder="ABCDE1234F"
              className="
                w-full px-4 py-3 rounded-xl border border-gray-200
                focus:outline-none focus:ring-2 focus:ring-red-800
              "
            />
          </div>

          {/* Aadhaar Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Aadhaar
            </label>

            <input
              type="file"
              className="
                block w-full text-sm text-gray-500
                file:mr-4
                file:px-4
                file:py-2
                file:rounded-xl
                file:border-0
                file:bg-red-50
                file:text-red-800
                hover:file:bg-red-100
              "
            />
          </div>

          {/* PAN Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload PAN
            </label>

            <input
              type="file"
              className="
                block w-full text-sm text-gray-500
                file:mr-4
                file:px-4
                file:py-2
                file:rounded-xl
                file:border-0
                file:bg-red-50
                file:text-red-800
                hover:file:bg-red-100
              "
            />
          </div>

        </div>
      </div>

    </div>
  );
}
